export const PlaceholderCellRender = () => {
  return (
    <td>
      {" "}
      <span className="k-placeholder-line" />
    </td>
  );
};
